import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem } from 'react-bootstrap';
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap';

import i18n from 'kodyl-js/i18n/react';
import Badge from '../common/badge';

class ProfileNav extends Component {
  render() {
    const { subscriber } = this.props;

    return (
      <Nav bsStyle="tabs" id="profile-navigation">
        <IndexLinkContainer to="/profile">
          <NavItem eventKey="1">
            {this.i18n('Edit profile')} <Badge />
          </NavItem>
        </IndexLinkContainer>
        <LinkContainer to="/profile/password">
          <NavItem eventKey="2">{this.i18n('Change Password')}</NavItem>
        </LinkContainer>
        <LinkContainer to="/profile/boligagent">
          <NavItem eventKey="3">{this.i18n('BoligAgent')}</NavItem>
        </LinkContainer>

        {!subscriber ? (
          <LinkContainer to="/profile/subscription">
            <NavItem eventKey="5">{this.i18n('Tenant ad')}</NavItem>
          </LinkContainer>
        ) : null}
        {subscriber ? (
          <LinkContainer to="/profile/tenant">
            <NavItem className="tenant-link" eventKey="4">
              {this.i18n('Tenant ad')}
            </NavItem>
          </LinkContainer>
        ) : null}
        {subscriber ? (
          <LinkContainer to="/profile/subscription">
            <NavItem className="subscription-tab" eventKey="5">
              {this.i18n('Subscription')}
            </NavItem>
          </LinkContainer>
        ) : null}
      </Nav>
    );
  }
}

export default connect(
  ({ auth: { user }, subscriptions: { subscriber } }) => ({ user, subscriber }),
  null,
  null,
  { pure: false }
)(i18n(ProfileNav));
